export const TWILIO_CALL = {
	TARGETS: {
		AGENT: 'agent',
		CUSTOMER: 'customer',
	},
} as const;
